import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function Notes({ color = 'icon.primary', fill = 'transparent', ...props }) {
  return (
    <IconBase viewBox='0 0 24 24' {...props}>
      <Path
        d='M15 8.99219H17'
        stroke={color}
        fill={fill}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M7 16.9883H9'
        stroke={color}
        fill={fill}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M12 16.9883H17'
        stroke={color}
        fill={fill}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M19 3.99609C20.105 3.99609 21 4.89044 21 5.99463V18.9851C21 20.0893 20.105 20.9836 19
           20.9836H5C3.895 20.9836 3 20.0893 3 18.9851V5.99463C3 4.89044 3.895 3.99609 5 3.99609'
        stroke={color}
        fill={fill}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M7 12.9922H9'
        stroke={color}
        fill={fill}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M12 12.9922H17'
        stroke={color}
        fill={fill}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10 2.99609H8C7.448 2.99609 7 3.44377 7 3.99536V8.99169L9 7.99243L11 8.99169V3.99536C11 3.44377
          10.552 2.99609 10 2.99609Z'
        stroke={color}
        fill={fill}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M5 3.99609H7'
        stroke={color}
        fill={fill}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M11 3.99609H19'
        stroke={color}
        fill={fill}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </IconBase>
  )
}

Notes.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
}

export default Notes
